import { useMemo } from 'react';
import buildUICategories, { type UiCategory } from 'hooks/marking/ui-categories-builder';
import type { ResponseItem } from 'services/assist-api/entities/test-instance-response/types';
import type { TestItemWithRubricItems } from 'services/assist-api/entities/test-item/test-items';
import type { TestRubricItemWithOptions } from 'services/assist-api/entities/test-rubric-item/types';

export default function useUiCategoriesForMarking(
  testItems: TestItemWithRubricItems[] | undefined,
  allResponseItems: ResponseItem[] | undefined,
  allRubricItems: TestRubricItemWithOptions[] | undefined
): UiCategory[] {
  return useMemo(
    () =>
      testItems && allResponseItems && allRubricItems
        ? buildUICategories(testItems, allResponseItems, allRubricItems)
        : [],
    [testItems, allResponseItems, allRubricItems]
  );
}
